var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.44C15.7875 13.44 18.8571 10.4317 18.8571 6.72C18.8571 3.00825 15.7875 0 12 0C8.2125 0 5.14286 3.00825 5.14286 6.72C5.14286 10.4317 8.2125 13.44 12 13.44ZM16.8 15.12H15.9054C14.7161 15.6555 13.3929 15.96 12 15.96C10.6071 15.96 9.28929 15.6555 8.09464 15.12H7.2C3.225 15.12 0 18.2805 0 22.176V24.36C0 25.7512 1.15179 26.88 2.57143 26.88H21.4286C22.8482 26.88 24 25.7512 24 24.36V22.176C24 18.2805 20.775 15.12 16.8 15.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile-image.8663f4eca8ff01a7bd7c6f25304de00d.svg";
export { ForwardRef as ReactComponent };